import React from 'react';
import { Shield, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface SelfVerificationBannerProps {
  partnerUsername: string;
}

export const SelfVerificationBanner: React.FC<SelfVerificationBannerProps> = ({
  partnerUsername
}) => {
  const navigate = useNavigate();

  return (
    <div className="bg-gradient-to-r from-[#9F3764]/20 to-[#C4406B]/20 border-b border-luxury-pinkBright/30 px-4 py-2.5">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <div className="flex-shrink-0 w-8 h-8 rounded-full bg-luxury-pinkBright/20 flex items-center justify-center">
            <Shield className="w-4 h-4 text-luxury-pinkBright" />
          </div>
          <div className="min-w-0">
            <p className="text-sm text-white leading-tight">
              Não quer que <span className="font-semibold">{partnerUsername}</span> veja isso?
            </p>
            <p className="text-xs text-white/60 leading-tight">
              Verifique seu perfil para remover este aviso
            </p>
          </div>
        </div>
        <button
          onClick={() => navigate('/main/verify')}
          className="flex-shrink-0 flex items-center gap-1.5 bg-gradient-to-r from-[#C4406B] to-[#9F3764] text-white text-xs font-medium px-3 py-1.5 rounded-lg hover:opacity-90 transition-opacity"
        >
          Verificar
          <ArrowRight className="w-3 h-3" />
        </button>
      </div>
    </div>
  );
};
